var Tabs = (function($) {

  var _s = {
    container: '.chm-block-tabs',
    tab_container: '.tabs-container',
    tab_trigger: '.tabs-container .tab-trigger',
    tab_content: '.tab-content',
    spotlight_container: '.spotlight-container',
    spotlight: '.spotlight'
  };

  // URL Parameters - Get and Split URL
  var getUrlParameter = function(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  // Slugify
  var slugify = function(string) {
    let slug = string.toLowerCase().replace(/ /g,'-').replace(/[-]+/g, '-').replace(/[^\w-]+/g,''); // Slugify

    return slug;
  };


  var _init = function() {
    _bindEvents();

    let active_tab = (getUrlParameter('tab'));

    if ( active_tab ) {
      active_tab = slugify(active_tab);
      
      $(_s.tab_trigger).each(function(i) {

        if ( active_tab == slugify($(this).text()) ) {
          $(this).trigger('click');
          $('html, body').stop().animate({
            scrollTop: $(_s.container).offset().top - 100
          },800);
        }

        if ( $(_s.tab_trigger+'.active').length == 0 ) {
          $(_s.container).find('.tab-trigger[data-tab-id]').first().trigger('click');
        }
      });
      
      
    } else {
      $(_s.container).find('.tab-trigger[data-tab-id]').first().trigger('click');
    }

  };

  var _bindEvents = function() {

    // Tabs
    $(_s.tab_trigger).on('click', function(i) {
      let parent = $(this).parents(_s.container);
      let tab_id = $(this).attr('data-tab-id');

      $(this).siblings().removeClass('active');
      parent.find(_s.tab_content).removeClass('active');
      parent.find(_s.spotlight).removeClass('active');

      parent.find('[data-tab-id="'+tab_id+'"]').addClass('active');
    });

    
  };

  return {
    init: _init
  };

})(jQuery);